const BackgroundShapes = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      <div className="absolute w-[600px] h-[600px] bg-primary rounded-full opacity-[0.03] -top-[15%] -right-[10%] animate-float1"></div>
      <div className="absolute w-[400px] h-[400px] bg-secondary rounded-full opacity-[0.03] -bottom-[10%] -left-[8%] animate-float2"></div>
      <div className="absolute w-[300px] h-[300px] bg-primary-light rounded-full opacity-[0.03] top-[50%] left-[30%] animate-float3"></div>
    </div>
  );
};

export default BackgroundShapes;
